import MyCalendar from "../components/Calendar/Calendar";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useAuth } from "../context/AuthContext";

const Calendar = () => {
  const { company } = useAuth();

  if (!company?.modules?.isCalendarAvailable) {
    return (
      <Container>
        <PageHeader pageTitle="Takvim" />
        <p style={{ color: "#888", marginTop: 24 }}>Bu modül şirketiniz için aktif değil.</p>
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader pageTitle="Takvim" />
      <MyCalendar />
    </Container>
  );
};

export default Calendar;
